module.exports = __webpack_public_path__ + "static/media/about4.d5efa6de.jpg";